<template>
  <div class="floating-panel">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FloatingPanel',
};
</script>

<style lang="scss" scoped>
  .floating-panel {
    background: rgba(0, 0, 0, 80%);

    color: white;

    padding: 15px;

    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;

    text-align: center;
  }
</style>
